import React from "react";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bottom-0 left-0 w-full bg-gray-100 border-t border-gray-200 py-4 z-50">
      {/* Main Footer Links */}
      <div className="text-center text-gray-600 text-sm mb-2 px-4">
        <span>© Copyright Dental Laboratories Alliance 2026. All rights reserved | </span>

        <span
          className="mx-1 text-[#70B444] cursor-pointer hover:underline"
          onClick={() => navigate("/about")}
        >
          About Us
        </span>

        <span> | </span>

        <span
          className="mx-1 text-[#70B444] cursor-pointer hover:underline"
          onClick={() => navigate("/our-policies")}
        >
          Policies
        </span>

        <span> | </span>

        <span
          className="mx-1 text-[#70B444] cursor-pointer hover:underline"
          onClick={() => navigate("/contact")}
        >
          Contact Us
        </span>
      </div>

      {/* Company Info */}
      <div className="text-center text-gray-500 text-xs px-4">
        <p>
  House no, 183 St 4, Block C, Punjab CHS, Cantt, 54000 Lahore, Pakistan        </p>
      </div>
    </footer>
  );
}

export default Footer;
